import APIURLConstants from "../common/ApiURLConstants";
import APIHelper from "../common/ApiHelper";
import { authHeader } from "../helper";

export const PlayerProfileService = {
  getPlayerListByEventIdYear,
  getPlayerListPageByEventIdYear,
  getPalyerStatsdata,
  getPalyerStatsdataPercentile,
  getPlayersProfileData,
  getPlayerCountryList,
  getPlayerStateList,
  getPlayerPositions,
  getCollegeClassList,
  getCollegeConferenceList,
  getHighSchoolEventsData,
  getRankingsData,
  insertUpdatePlayerProfileDetails,
  insertUpdatePlayerAgentDetails,
  insertUpdateCollegeDetails,
  insertUpdateProfExperienceDetails,
  insertUpdateGLeagueExperienceDetails,
  insertUpdateHighSchoolDetails,
  insertUpdateClubProgramDetails,
  insertUpdateIntTeamExpDetails,
  insertUpdateHighSchoolEvents,
  insertUpdateRankings,
  updateProfileImageName,
  getPlayerListByCombineYear,
  getAnthrosDataByPlayerId,
  getAnthrosDataByPlayerIdRanking,
  getAnthrosDataByPlayerYear,
  savePlayerFileDetails,
  getPlayersStrengthAndAgilityData,
  getPlayersStrengthAndAgilityDataRanking,
  getShootingDrillSummaryByPlayerId,
  getFullcourtAndWorkoutVideos,
  delPlayerFileDetails,
  getShootingDrillsOverallSummaryByPlayerId,
  getFavPlayersByUserNameAndEventId,
  insUpFavPlayers,
  getPLayerPODDetails,
  insertPlayerDetails,
  getCounterMovementByPlayerId,
  getCounterMovementsStatisons,
  insertPlayerMediaDetails,
  deletePlayerMediaDetails,
  getConterMovementUrl,
};
async function getPlayerListByEventIdYear(eventId, userBy = null) {
  const response = await APIHelper.get(
    APIURLConstants.GET_PLAYERS_LIST_BY_EVENT_ID_YEAR(eventId, userBy),
    authHeader()
  );
  return response;
}
async function getPlayerListPageByEventIdYear(eventId, userBy) {
  const response = await APIHelper.get(
    APIURLConstants.GET_PLAYERS_LIST_PAGE_BY_EVENT_ID_YEAR(eventId, userBy),
    authHeader()
  );
  return response;
}
async function getPalyerStatsdata(obj) {
  const response = await APIHelper.post(
    `${APIURLConstants.GET_PLAYERS_STATS_DATA}`,
    obj,
    authHeader()
  );
  return response;
}
async function getPalyerStatsdataPercentile(obj) {
  const response = await APIHelper.post(
    `${APIURLConstants.GET_PLAYERS_STATS_DATA_Percentile}`,
    obj,
    authHeader()
  );
  return response;
}
async function getPlayersProfileData(id, eventId, userBy) {
  const response = await APIHelper.get(
    APIURLConstants.GET_PLAYERS_PROFILE_DATA(id, eventId, userBy),
    authHeader()
  );
  return response;
}
async function getPlayerCountryList() {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_PLAYER_COUNTRY_LIST}`,
    authHeader()
  );
  return response;
}
async function getPlayerStateList() {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_PLAYER_STATE_LIST}`,
    authHeader()
  );
  return response;
}
async function getPlayerPositions() {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_PLAYER_POSITIONS}`,
    authHeader()
  );
  return response;
}
async function getCollegeClassList() {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_COLLEGE_CLASS_LIST}`,
    authHeader()
  );
  return response;
}
async function getCollegeConferenceList() {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_COLLEGE_CONFERENCE_LIST}`,
    authHeader()
  );
  return response;
}
async function getHighSchoolEventsData() {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_HIGH_SCHOOL_EVENTS_DATA}`,
    authHeader()
  );
  return response;
}
async function getRankingsData() {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_RANKINGS_DATA}`,
    authHeader()
  );
  return response;
}
async function insertUpdatePlayerProfileDetails(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.INSERT_UPDATE_PLAYER_PROFILE_DETAILS}`,
    formObj,
    authHeader()
  );
  return response;
}
async function insertUpdatePlayerAgentDetails(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.INSERT_UPDATE_PLAYER_AGENT_DETAILS}`,
    formObj,
    authHeader()
  );
  return response;
}
async function insertUpdateCollegeDetails(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.INSERT_UPDATE_COLLEGE_DETAILS}`,
    formObj,
    authHeader()
  );
  return response;
}
async function insertUpdateProfExperienceDetails(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.INSERT_UPDATE_PROF_EXPERIENCE_DETAILS}`,
    formObj,
    authHeader()
  );
  return response;
}
async function insertUpdateGLeagueExperienceDetails(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.INSERT_UPDATE_GLEAGUE_EXPERIENCE_DETAILS}`,
    formObj,
    authHeader()
  );
  return response;
}
async function insertUpdateHighSchoolDetails(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.INSERT_UPDATE_HIGH_SCHOOL_DETAILS}`,
    formObj,
    authHeader()
  );
  return response;
}
async function insertUpdateClubProgramDetails(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.INSERT_UPDATE_CLUB_PROGRAM_DETAILS}`,
    formObj,
    authHeader()
  );
  return response;
}
async function insertUpdateIntTeamExpDetails(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.INSERT_UPDATE_INT_TEAM_EXP_DETAILS}`,
    formObj,
    authHeader()
  );
  return response;
}
async function insertUpdateHighSchoolEvents(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.INSERT_UPDATE_HIGH_SCHOOL_EVENTS}`,
    formObj,
    authHeader()
  );
  return response;
}
async function insertUpdateRankings(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.INSERT_UPDATE_RANKINGS}`,
    formObj,
    authHeader()
  );
  return response;
}

async function updateProfileImageName(formObj) {
  const response = await APIHelper.post(
    `${APIURLConstants.UPDATE_PLAYER_HEADSHOT_URL}`,
    formObj,
    authHeader()
  );
  return response;
}

async function getPlayerListByCombineYear(combineYear, playerId, eventId) {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_PLAYER_STATS_DATA}/${combineYear}/${playerId}/${eventId}`,
    authHeader()
  );
  return response;
}

async function getAnthrosDataByPlayerId(eventId, playerId, userBy) {
  const response = await APIHelper.get(
    APIURLConstants.GET_ANTHROS_DATA_BY_PLAYER_ID(eventId, playerId, userBy),
    authHeader()
  );
  return response;
}
async function getAnthrosDataByPlayerIdRanking(eventId, playerId, userBy) {
  const response = await APIHelper.get(
    APIURLConstants.GET_ANTHROS_Ranking_DATA_BY_PLAYER_ID(
      eventId,
      playerId,
      userBy
    ),
    authHeader()
  );
  return response;
}
async function getAnthrosDataByPlayerYear(eventId, playerId) {
  const response = await APIHelper.get(
    APIURLConstants.GET_ANTHROS_Ranking_DATA_BY_PLAYER_Year(eventId, playerId),
    authHeader()
  );
  return response;
}
async function savePlayerFileDetails(formObj) {
  const response = await APIHelper.post(
    APIURLConstants.SAVE_PLAYER_FILE_DETAILS,
    formObj,
    authHeader()
  );
  return response;
}

async function getPlayersStrengthAndAgilityData(eventId, playerId, userBy) {
  const response = await APIHelper.get(
    APIURLConstants.GET_PLAYERS_STRENGTH_AND_AGILITY_DATA(
      eventId,
      playerId,
      userBy
    ),
    authHeader()
  );
  return response;
}

async function getPlayersStrengthAndAgilityDataRanking(
  eventId,
  playerId,
  userBy
) {
  const response = await APIHelper.get(
    APIURLConstants.GET_PLAYERS_STRENGTH_AND_AGILITY_DATA_Ranking(
      eventId,
      playerId,
      userBy
    ),
    authHeader()
  );
  return response;
}
async function getShootingDrillSummaryByPlayerId(
  eventId,
  stationId,
  playerId,
  userBy
) {
  const response = await APIHelper.get(
    APIURLConstants.GET_SHOOTING_DRILL_SUMMARY_BY_PLAYER_ID(
      eventId,
      stationId,
      playerId,
      userBy
    ),
    authHeader()
  );
  return response;
}

async function getFullcourtAndWorkoutVideos(eventId, stationId, playerId) {
  const response = await APIHelper.get(
    APIURLConstants.GET_Full_Court_AND_Workout_Videos_PLAYER_ID(
      eventId,
      stationId,
      playerId
    ),
    authHeader()
  );
  return response;
}

async function delPlayerFileDetails(fileID) {
  const response = await APIHelper.post(
    `${APIURLConstants.DEL_PLAYER_FILE_DETAILS}/${fileID}`,
    null,
    authHeader()
  );
  return response;
}

async function getShootingDrillsOverallSummaryByPlayerId(
  eventId,
  playerId,
  userBy
) {
  const response = await APIHelper.get(
    APIURLConstants.GET_SHOOTING_DRILLS_OVERALL_SUMMARY_BY_PLAYER_ID(
      eventId,
      playerId,
      userBy
    ),
    authHeader()
  );
  return response;
}

async function getFavPlayersByUserNameAndEventId(eventId, userName) {
  const response = await APIHelper.get(
    APIURLConstants.GET_FAV_PLAYERS_BY_USER_NAME_AND_EVENTID(eventId, userName),
    authHeader()
  );
  return response;
}

async function insUpFavPlayers(favPlayers) {
  const response = await APIHelper.post(
    `${APIURLConstants.INS_UPD_FAV_PLAYER}`,
    favPlayers,
    authHeader()
  );
  return response;
}
async function getPLayerPODDetails() {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_PLAYER_POD_DETAILS}`,
    authHeader()
  );
  return response;
}

async function insertPlayerDetails(PlayerDetails) {
  const response = await APIHelper.post(
    `${APIURLConstants.INSERT_PLAYER_DETAILS}`,
    PlayerDetails,
    authHeader()
  );
  return response;
}

async function getCounterMovementByPlayerId(eventId, stationId, playerId) {
  const response = await APIHelper.get(
    APIURLConstants.GET_COUNTER_MOVEMENT_BY_PLAYER_ID(
      eventId,
      stationId,
      playerId
    ),
    authHeader()
  );
  return response;
}

async function getCounterMovementsStatisons() {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_COUNTER_MOVEMENTS_STATIONS}`,
    authHeader()
  );
  return response;
}

async function insertPlayerMediaDetails(PlayerDetails) {
  const response = await APIHelper.post(
    `${APIURLConstants.INSERT_PLAYER_MEDIA_DETAILS}`,
    PlayerDetails,
    authHeader()
  );
  return response;
}

async function deletePlayerMediaDetails(
  eventId,
  playerID,
  UserBy,
  fileDetails
) {
  const response = await APIHelper.post(
    `${APIURLConstants.DELETE_PLAYER_MEDIA_DETAILS}?EventId=${eventId}&PlayerId=${playerID}&StationId=${fileDetails.stationId}&Attempt=${fileDetails.attempt}&AngleType=${fileDetails.angleType}&UserBy=${UserBy}`,
    authHeader()
  );
  return response;
}

async function getConterMovementUrl() {
  const response = await APIHelper.get(
    APIURLConstants.GET_COUNTER_MOVEMENT_URL,
    authHeader()
  );
  return response;
}
